<template>
  <div v-if="customerStore.studio" class="flex flex-col items-stretch bg-primary">
    <div
      class="flex h-28 w-full grow items-center justify-center self-center lg:justify-start lg:pl-4 banner:max-w-6xl banner:pl-0"
    >
      <div class="flex w-full flex-col items-start gap-y-4 px-4 py-5 banner:max-w-6xl banner:px-0">
        <m-link v-if="customerStore.studio.contactPhone" :href="`tel:${customerStore.studio.contactPhone}`">
          <div class="flex items-center gap-2 font-bold text-white">
            <m-icon :icon="faPhone" />
            {{ customerStore.studio.contactPhone }}
          </div>
        </m-link>

        <m-link v-if="customerStore.studio.contactEmail" :href="`mailto:${customerStore.studio.contactEmail}`">
          <div class="flex items-center gap-2 font-bold text-white">
            <m-icon :icon="faEnvelope" />
            {{ customerStore.studio.contactEmail }}
          </div>
        </m-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
  import { useCustomerStore } from '@apps/customer/stores/customer.store';
  const customerStore = useCustomerStore();
</script>
